<template>
  <div class="text-start">
    <CourseNumberField
      :label="$t('course.courseDetails.courseDuration')"
      :value="trainingDuration"
      @update:value="trainingDuration = $event"
      :isEditing="isEditing"
      css-class="subtitle-2 font-weight-regular textLight--text mb-3"
      :class="isEditing ? 'mb-6' : ''"
    />
  </div>
</template>

<script>
import CourseNumberField from "@/app/course-module/components/course-details/CourseNumberField";

export default {
  name: "CourseDuration",
  components: { CourseNumberField },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    trainingDuration: {
      get() {
        return this.training.duration ?? "";
      },
      set(value) {
        this.$emit("update:training", {
          ...this.training,
          duration: this.getInteger(value),
          hasChangesInDuration: true,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped />
